const { industryArray } = require("../data/industry");
const { exportCSVFile } = require("../data/json_to_csv");
export const getDownloadLists = (e) => {
  e.preventDefault();
  console.log("downloading...");
  let downloadType = e.target.getAttribute("data-id");
  fetch("../api/programs/get_program_info.php")
    .then((response) => response.json())
    .then((res) => {
      let attendees = res.attendees;
      let users = attendees.map((list) => list.user);
      users.sort((a, b) =>
        a.lastName > b.lastName ? 1 : b.lastName > a.lastName ? -1 : 0
      );
      let months = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];
      let d = new Date();
      let m = d.getMonth();
      let y = d.getFullYear();
      let nd = d.getDate();
      let ms = d.getMilliseconds();
      let now = `${months[m]}_ ${nd}_${y}_${ms}`;
      let fileName;
      // getAttendeesLists(downloadLists);
      if (downloadType == "filtered") {
        fileName = `filtered_attendeeList_${now}`;
        getFilteredList(users, fileName);
      } else {
        fileName = `Unfiltered_attendeeList_${now}`;
        getAttendeesLists(users, fileName);
      }
    });
};

const getFilteredList = (list) => {
  let filteredIndustry = [];
  list.filter((fx) => {
    industryArray.forEach((fz) => {
      if (fx.email !== null) {
        if (fx.email.includes(fz)) {
          filteredIndustry.push(fx);
        }
      }
    });
    return filteredIndustry;
  });
  let filteredList = list.filter((cd) => {
    return !filteredIndustry.includes(cd);
  });
  getAttendeesLists(filteredList);
};

const getAttendeesLists = (downloadLists, fileName) => {
  let headers = {
    MemberID: "Member ID",
    firstName: "First Name",
    lastName: "Last Name",
    degree: "Degree",
    affiliation: "Affiliation",
    email: "Email",
    city: "City",
    state: "State",
  };
  let itemsFormatted = [];
  // format the data
  downloadLists.forEach((item) => {
    itemsFormatted.push({
      memberID: item.user_id,
      firstName: item.firstName,
      lastName: item.lastName,
      degree: item.degree,
      affiliation: item.affiliation,
      email: item.email,
      city: item.city,
      state: item.state,
    });
  });

  exportCSVFile(headers, itemsFormatted, fileName);
  console.log(itemsFormatted);
};
